import React from "react";
import { IoIosSettings } from "react-icons/io";
import { FaUser, FaSearch, FaHome } from "react-icons/fa";

export const NavbarData = [
  {
    title: "Home",
    path: "/",
    icon: <FaHome style={{ fontSize: "20px" }} />,
    className: "nav-text",
  },
  {
    title: "Profile",
    path: (id) => `/user-profile/${id}`,
    icon: <FaUser />,
    className: "nav-text dependent",
  },
  {
    title: "Search",
    path: "/search",
    icon: <FaSearch />,
    className: "nav-text",
  },
];
